import { render, staticRenderFns } from "./Descuentos.vue?vue&type=template&id=c59205a0&scoped=true&"
import script from "./Descuentos.vue?vue&type=script&lang=js&"
export * from "./Descuentos.vue?vue&type=script&lang=js&"
import style0 from "./Descuentos.vue?vue&type=style&index=0&id=c59205a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59205a0",
  null
  
)

export default component.exports